// src/store/productCategoryManagment/types.ts

import { ProductCategory } from '../../dataTypes/productManagment/types';

export const FETCH_PRODUCT_CATEGORY_REQUEST = 'FETCH_PRODUCT_CATEGORY_REQUEST';
export const FETCH_PRODUCT_CATEGORY_SUCCESS = 'FETCH_PRODUCT_CATEGORY_SUCCESS';
export const FETCH_PRODUCT_CATEGORY_FAILURE = 'FETCH_PRODUCT_CATEGORY_FAILURE';

export interface ProductCategoryState {
  loading: boolean;
  categories: Map<number, ProductCategory>;
  error: string | null;
  lastFetchTimestamp: number;
}

export const initialState: ProductCategoryState = {
  loading: false,
  categories: new Map(),
  error: null,
  lastFetchTimestamp: 0,
};

export interface FetchProductCategoryRequestAction {
  type: typeof FETCH_PRODUCT_CATEGORY_REQUEST;
}

export interface FetchProductCategorySuccessAction {
  type: typeof FETCH_PRODUCT_CATEGORY_SUCCESS;
  payload: {
    categories: ProductCategory[];
    lastFetchTimestamp: number;
  };
}

export interface FetchProductCategoryFailureAction {
  type: typeof FETCH_PRODUCT_CATEGORY_FAILURE;
  payload: string;
}

export type ProductCategoryActionTypes =
  | FetchProductCategoryRequestAction
  | FetchProductCategorySuccessAction
  | FetchProductCategoryFailureAction;